<template>
  <div class="index">
    <div class="chat-list">
      <div class="nav-title">发蜘客</div>
      <div class="chat-list-user">
        <div
          v-for="(item, index) in chatList"
          :key="index"
          @click="lookChatRecords(index)"
          :class="current == index ? 'active-background' : 'user-info'"
        >
          <div class="expression-steps">
            <p>{{ item.name }}</p>
            <p v-if="item.num">{{ item.num }}</p>
          </div>
          <div v-if="item.name == '垃圾箱'" class="empty" @click.stop="handleEmpty">
            [清空]
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑 -->
    <edit-detail
      v-if="current == 0"
      @draftsUpdateTotal="draftsUpdateTotal"
      @editChangeCurrent="editChangeCurrent"
      @alreadyUpdateTotal="alreadyUpdateTotal"
      @privateUpdateTotal="privateUpdateTotal"
      @nextStep="nextStep"
      ref="editDetail"
    ></edit-detail>
    <!-- 设置标签 -->
    <setting-detail
      v-if="current == 5"
      @backStep="backStep"
      @publishSuccess="publishSuccess"
      :articleData="articleData"
      :articleId="articleId"
      :saveStatus="articleSaveStatus"
    ></setting-detail>
    <!-- 草稿箱 -->
    <drafts-detail
      v-if="current == 1"
      @draftsUpdateTotal="draftsUpdateTotal"
      @editArticl="editArticl"
      @dustbinUpdateTotal="dustbinUpdateTotal"
    ></drafts-detail>
    <!-- 已发公开稿件 -->
    <already-sent-manuscript
      v-if="current == 2"
      @alreadyUpdateTotal="alreadyUpdateTotal"
      @editArticl="editArticl"
      @dustbinUpdateTotal="dustbinUpdateTotal"
    ></already-sent-manuscript>
    <!-- 已发私密稿件 -->
    <already-sent-private-manuscript
      v-if="current == 3 && privatePasswordCorrect"
      @privateUpdateTotal="privateUpdateTotal"
      @editArticl="editArticl"
      @dustbinUpdateTotal="dustbinUpdateTotal"
    ></already-sent-private-manuscript>
    <!-- 垃圾箱 -->
    <dustbin-detail
      :clearStatus="clearStatus"
      v-if="current == 4"
      ref="dustbin"
      @dustbinUpdateTotal="dustbinUpdateTotal"
      @draftsUpdateTotal="draftsUpdateTotal"
      @alreadyUpdateTotal="alreadyUpdateTotal"
    ></dustbin-detail>
    
    <!-- 私密稿件密码弹窗 -->
    <el-dialog
      title="请输入私密稿件密码"
      :visible.sync="privateDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="{ password: privatePassword }" label-width="60px">
        <el-form-item label="密码" style="margin-bottom: 0;">
          <el-input v-model="privatePassword" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0;">
          <div style="color: #909399; font-size: 14px;">
            提示：先在手机端设置密码
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPrivatePassword">取消</el-button>
        <el-button type="primary" @click="validatePrivatePassword">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import editDetail from "./components/editDetail";
import draftsDetail from "./components/draftsDetail";
import alreadySentManuscript from "./components/alreadySentManuscript";
import alreadySentPrivateManuscript from "./components/alreadySentPrivateManuscript";
import dustbinDetail from "./components/dustbinDetail";
import settingDetail from "./components/settingDetail";
import articleApi from "@/api/apiModel/article";
export default {
  name: "uploadExpression",
  components: {
    editDetail,
    draftsDetail,
    alreadySentManuscript,
    alreadySentPrivateManuscript,
    dustbinDetail,
    settingDetail,
  },
  data() {
    return {
      current: 0,
      isShow: true,
      // clearStatus:true, //清空的状态 刷新垃圾箱子组件
      clearStatus:0, //每次清空就传给子组件 子组件监听变化就掉数据列表的接口
      chatList: [
        { name: "编辑" },
        { name: "草稿箱", num: '' },
        { name: "已发公开稿件", num: '' },
        { name: "已发私密稿件", num: '' },
        { name: "垃圾箱", num: '' },
      ],
      // 私密稿件相关
      privateDialogVisible: false,
      privatePassword: '',
      privatePasswordCorrect: false,
      articleData: {}, // 文章数据
      articleId: '', // 文章ID
      articleSaveStatus: 0, // 保存状态 0新增 1编辑
    };
  },
  created() {
    this.getArticleList(); //初始化数量
  },
  methods: {
    // 查看对应用户聊天记录
    lookChatRecords(index) {
      // 如果点击的是私密稿件，显示密码弹窗
      if (index === 3) {
        this.privateDialogVisible = true;
      } else {
        this.current = index;
        this.isShow = false;
      }
    },
    // 验证私密稿件密码
    validatePrivatePassword() {
      if(!this.privatePassword){
        this.$message({
          message: '请输入密码',
          type: 'error'
        });
        return
      }
      ////// 测试
      // if(this.privatePassword){
      //   this.privatePasswordCorrect = true; 
      //   this.privateDialogVisible = false;
      //   this.current = 3;
      //   this.isShow = false;
      //   return
      // }
      
      // 这里可以根据实际需求设置密码验证逻辑
      let userInfo = JSON.parse(localStorage.getItem("loginMsg")); //存在缓存的用户信息
      articleApi.validatePrivatePassword(userInfo.memberId, 
      { password: this.privatePassword }).then(res=>{
        if(res.result){
          this.privatePasswordCorrect = true; 
          this.privateDialogVisible = false;
          this.current = 3;
          this.isShow = false;
          // this.$message({
          //   message: '密码正确，欢迎访问私密稿件',
          //   type: 'success'
          // });
        } else {
          this.$message({
            message: '密码错误，请重新输入',
            type: 'error'
          });
        }
      })
    },
    // 取消私密稿件密码验证
    cancelPrivatePassword() {
      this.privateDialogVisible = false;
      this.privatePassword = '';
      this.privatePasswordCorrect = false;
      // 跳回发蜘客界面（编辑页面）
      this.current = 0;
    },
    // 清空
    handleEmpty() {
       articleApi.clearRubbish().then(res=>{
          //刷新组件的方法会闪烁 
          // this.clearStatus = false
          // setTimeout(()=>{
          //    this.clearStatus = true
          // },100)
          this.clearStatus++ //改变数据 传给子组件
          this.$message({
              message: '清空成功',
              type: 'success'
        });
        this.getArticleList()
      })
      // this.$refs.dustbin.clearEmpty()
    },
    //初始化数量
    getArticleList() {
      // 使用getArticleTypes接口获取公开和私密稿件数量
      articleApi
        .getArticleTypes()
        .then((res) => {
          // 处理接口返回的数据结构
          if (res.result && res.result.length > 0) {
            res.result.forEach(item => {
              if (item.typeName === '公开文章') {
                this.chatList[2].num = item.articleCount || 0;
              } else if (item.typeName === '私密文章') {
                this.chatList[3].num = item.articleCount || 0;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      
      // 草稿箱数量
      articleApi
        .articleList({ status: 0 })
        .then((res) => {
          // console.log("文章列表",res.result.total)
          this.chatList[1].num = res.result.total;
        })
        .catch((err) => {
          console.log(err);
        });
      
      // 垃圾箱数量
      articleApi
        .rubbishList()
        .then((res) => {
          // console.log("垃圾箱列表",res.result.total)
          this.chatList[4].num = res.result.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //已发公开稿件的总数更新
    alreadyUpdateTotal(total) {
      this.$store.dispatch("changeNum", "发蜘客");
      this.chatList[2].num = total;
    },
    //已发私密稿件的总数更新
    privateUpdateTotal(total) {
      this.$store.dispatch("changeNum", "发蜘客");
      this.chatList[3].num = total;
    },
    //草稿箱的总数更新
    draftsUpdateTotal(total) {
      this.$store.dispatch("changeNum", "发蜘客");
      this.chatList[1].num = total;
    },
    //垃圾箱的总数更新
    dustbinUpdateTotal(total) {
      this.$store.dispatch("changeNum", "发蜘客");
      this.chatList[4].num = total;
      this.getArticleList()
    },

    //修改文章
    editArticl(item) {
      this.current = 0;
      setTimeout(() => {
        this.$refs.editDetail.edit(item);
      }, 500);
    },
    editChangeCurrent(id) {
      this.current = id;
    },
    // 下一步
    nextStep(data) {
      console.log('index nextStep called with data:', data);
      // 获取编辑界面的文章数据
      this.articleData = data.model;
      this.articleId = data.id;
      this.articleSaveStatus = data.saveStatus;
      console.log('articleData:', this.articleData);
      console.log('articleId:', this.articleId);
      console.log('articleSaveStatus:', this.articleSaveStatus);
      // 切换到设置标签页
      this.current = 5;
      console.log('current set to 5');
    },
    // 上一步
    backStep(settingFormData) {
      // 合并设置页传回的表单数据（价格、可见范围等），避免返回后丢失
      if (settingFormData) {
        this.articleData = Object.assign({}, this.articleData, settingFormData);
      }
      // 切换回编辑界面
      this.current = 0;
      // 延迟一下，确保组件已经渲染
      setTimeout(() => {
        // 将保存的文章数据传递回编辑组件
        if (this.$refs.editDetail && Object.keys(this.articleData).length > 0) {
          // 保持编辑状态
          this.$refs.editDetail.setArticleData(this.articleData);
          // 恢复编辑模式的状态
          if (this.articleSaveStatus === 1 && this.articleId) {
            this.$refs.editDetail.saveStatus = 1;
            this.$refs.editDetail.id = this.articleId;
          }
        }
      }, 500);
    },
    // 发布成功
    publishSuccess(visibleRange) {
      // 刷新文章列表
      this.getArticleList();
      // 根据可见范围切换到对应的稿件界面
      if (visibleRange === 1) {
        // 私密稿件，发布后直接进入已发私密稿件页面，不弹密码框
        this.privatePasswordCorrect = true;
        this.current = 3;
      } else {
        // 公开稿件
        this.current = 2;
      }
    },
  },
};
</script>

<style scoped>
.index {
  display: flex;
  flex: 1;
}
.chat-list {
  width: 253px;
  user-select: none;
  cursor: pointer;
  height: 100%;
  background: #ffffff;
}
.chat-list .chat-list-user {
  height: 100%;
  /* height: 473px; */
  overflow-x: hidden;
  overflow-y: auto;
}
.nav-title {
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  letter-spacing: 2px;
  padding: 10px;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  box-sizing: border-box;
  border-bottom: 1px solid #dcdfe6;
}
.chat-list-user .user-info {
  height: 57px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-bottom: 1px solid #dcdfe6;
  box-sizing: border-box;
}
.empty {
  font-size: 14px;
  color: #ff6632;
}
.user-info:hover {
  background: #f5f7fa;
}
.expression-steps {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  color: #313233;
}
.expression-steps p:nth-child(1) {
  margin-right: 8px;
}
.expression-steps p:nth-child(2) {
  font-size: 14px;
  color: #7b7d80;
}
.active-background {
  height: 57px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #f5f7fa;
  padding: 0 12px;
  border-bottom: 1px solid #dcdfe6;
  box-sizing: border-box;
}
</style>